// Line icons for meal categories, replacing the multicolor meal-type emoji
// (🥣/🥪/🍽️) so chips match the app's SVG icon style. Time-of-day + snack.
export function MealIcon({ meal, className = 'w-4 h-4' }) {
  const common = {
    className,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };

  switch (meal) {
    case 'breakfast': // coffee mug + steam
      return (
        <svg {...common}>
          <path d="M4 9h11v5a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9z" />
          <path d="M15 10h2.5a2.5 2.5 0 0 1 0 5H15" />
          <path d="M7 3c.6.8-.6 1.2 0 2M10.5 3c.6.8-.6 1.2 0 2" />
        </svg>
      );
    case 'lunch': // midday sun
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      );
    case 'dinner': // evening crescent moon
      return (
        <svg {...common}>
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
        </svg>
      );
    case 'snack': // cookie
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <circle cx="9" cy="10" r="1" fill="currentColor" stroke="none" />
          <circle cx="14.5" cy="9.5" r="1" fill="currentColor" stroke="none" />
          <circle cx="13" cy="14.5" r="1" fill="currentColor" stroke="none" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
        </svg>
      );
  }
}
